import React from 'react';
import { SvgIcon } from '@mui/material';

const SvgTickmarkCircle = (props) => (
  <SvgIcon {...props} title="TickmarkCircle">
    <svg
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0Zm4.95 8.23-5.66 5.66a.996.996 0 0 1-1.41 0l-2.83-2.83a.996.996 0 1 1 1.41-1.41l2.12 2.12 4.95-4.95a.996.996 0 0 1 1.41 0c.4.39.4 1.02.01 1.41Z"
        fill="#017163"
      />
    </svg>
  </SvgIcon>
);

export default SvgTickmarkCircle;
